import React from "react";
import { useTranslation } from 'react-i18next';
import BalikesirWhiteRiver from "../Components/quarries/BalikesirWhiteRiver";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import productSeoData from "../data/productSeoData.json";

function WhiteRiverPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = productSeoData[currentLang]?.whiteRiver || {
    title: currentLang === 'tr' ? 'White River Mermer - MOCA Mermer' : 'White River Marble - MOCA Marble',
    description: currentLang === 'tr' ? 'White River mermer ürünü hakkında detaylı bilgi. MOCA Mermer kalitesi ile.' : 'Detailed information about White River marble product. With MOCA Marble quality.',
    keywords: currentLang === 'tr' ? 'white river, mermer, doğal taş, moca mermer' : 'white river, marble, natural stone, moca marble'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/whiteriver"
        image={seo.image}
        structuredData={seo.structuredData}
      />
      <TopBar />
      <Spacer/>
      <BalikesirWhiteRiver />
    </>
  );
}

export default WhiteRiverPage;
